import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Session Management Functions
export const createSession = async (sessionName, password) => {
  return fetch(`${API_URL}/api/sessions/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionName, password })
  }).then(res => res.json());
};

export const editSession = async (sessionName, currentPassword, newPassword) => {
  return fetch(`${API_URL}/api/sessions/edit`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionName, currentPassword, newPassword })
  }).then(res => res.json());
};

export const deleteSession = async (sessionName, password) => {
  return fetch(`${API_URL}/api/sessions/delete`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionName, password })
  }).then(res => res.json());
};

export const verifySession = async (sessionName, password) => {
  return fetch(`${API_URL}/api/sessions/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionName, password })
  }).then(res => res.json());
};

export const listSessions = async () => {
  return fetch(`${API_URL}/api/sessions/list`, {
    method: 'GET'
  }).then(res => res.json());
};

// Existing functions
export const deleteParticipant = (session, id) =>
  axios.delete(`${API_URL}/api/${session}/admin/participants/${id}`);

export async function prevStage(session) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${session}/stage/prev`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(res => res.json());
}

export async function getCurrentStage(session) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${session}/stage`, {
    method: 'GET',
  }).then(res => res.json());
}

export async function nextStage(session) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${session}/stage/next`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(res => res.json());
}

export async function clearSession(session) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${session}/session/clear`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(res => res.json());
}

export const uploadParticipant = (session, data) =>
  axios.post(`${API_URL}/api/${session}/admin/upload`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getParticipants = (session, role) =>
  axios.get(`${API_URL}/api/${session}/vote/${role}`);

export async function voteParticipant(session, id, voterId) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${session}/vote/${id}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ voterId })
  }).then(res => res.json());
}
